import React from 'react';
import { aboutData } from '../data/mock';
import { Award, CheckCircle, Briefcase } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="bg-[#f1f5f9] py-24 lg:py-32">
      <div className="max-w-[87.5rem] mx-auto px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24">
          {/* Left Column - Main Content */}
          <div className="lg:w-1/2">
            <span className="text-[#3b82f6] text-sm font-semibold uppercase tracking-[0.1em] block mb-4">
              About
            </span>
            <h2 
              className="text-[#0f172a] font-black uppercase leading-[0.85] mb-8"
              style={{ 
                fontFamily: "'Inter', Arial, sans-serif",
                fontSize: 'clamp(2rem, 3rem + 1vw, 3.5rem)'
              }}
            >
              {aboutData.headline}
            </h2>
            
            <p className="text-[#475569] text-lg font-medium leading-relaxed mb-10">
              {aboutData.description}
            </p>

            {/* Values List */}
            <div className="space-y-4">
              {aboutData.values.map((value, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-[#3b82f6]/10 flex items-center justify-center flex-shrink-0">
                    <CheckCircle size={20} className="text-[#3b82f6]" />
                  </div>
                  <span className="text-[#475569] font-medium">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Stats */}
          <div className="lg:w-1/2">
            <div className="grid grid-cols-1 gap-6">
              {aboutData.highlights.map((highlight, index) => (
                <div 
                  key={index}
                  className="bg-white border border-[#e2e8f0] p-8 lg:p-10 rounded-lg transition-all duration-300 hover:shadow-lg hover:border-[#3b82f6]/30"
                >
                  <div className="flex items-center gap-6">
                    <div className="w-16 h-16 rounded-full bg-[#3b82f6]/10 flex items-center justify-center flex-shrink-0">
                      {index === 0 && <Briefcase size={28} className="text-[#3b82f6]" />}
                      {index === 1 && <Award size={28} className="text-[#3b82f6]" />}
                      {index === 2 && <CheckCircle size={28} className="text-[#3b82f6]" />}
                    </div>
                    <div>
                      <span 
                        className="text-[#0f172a] font-black block leading-none mb-2"
                        style={{ 
                          fontFamily: "'Inter', Arial, sans-serif",
                          fontSize: 'clamp(2.5rem, 3rem + 0.5vw, 4rem)'
                        }}
                      >
                        {highlight.number}
                      </span>
                      <span className="text-[#64748b] text-sm font-medium uppercase tracking-[0.1em]">
                        {highlight.label}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
